"use client";

import { useState } from "react";
import UserCard from "./user-card";

interface TeamMember {
    uuid: string;
    f_name: string;
    l_name: string;
    email: string;
    phone: string;
    department: string;
    designation: string;
    profile_image: string;
    description: string;
    linkedin_url?: string;
    twitter_url?: string;
    github_url?: string;
    skills: string;
}

export default function UserCardWrapper({ member }: { member: TeamMember }) {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleToggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <UserCard
            member={member}
            isExpanded={isExpanded}
            onToggleExpand={handleToggleExpand}
        />
    );
} 